import { Contact } from '../components/Contact';
import { useContactService } from '../services/useContactService';

export const ContactContainer: React.FC<React.PropsWithChildren<unknown>> = () => {
  const service = useContactService();

  return <Contact isInApp={service.isInApp} isMobile={service.isMobile} contactData={service.contactData} />;
};
